import { validate as validateUrl } from "./url";
import { validate as maxLength } from "./maxLength";
import { validate as minLength } from "./minLength";

export const useValidation = () => ({ validateUrl, maxLength, minLength });
